import React from "react"
import ApiService from "../../../services/ApiService"
import BlogList from "../theme/components/BlogList";
import logger from "../../../services/logger"

export default class ListRender extends React.Component{

    state = {
        data: [],
        loading: false,
        page:1,
        nbPages:1
    };

    componentDidMount() {
        this.setState({loading:true},()=>{
            this.getData(1)
        })
    }

    async getData(page=1)
    {
        const context=this.props.context
        const {org}=context

        this.setState({ loading: true });
        var res=await ApiService.get("/actualite/"+org.id+"?page="+page)
        logger.debug({ res }, "res")

        this.setState({
            loading: false,
            data: res.data,
            page:page,
            nbPages:res.nbPages
        });
    };


    render()
    {
        const context=this.props.context
        const {org}=context

        return(
          <div style={{padding:"50px 0"}}>


              {!this.state.loading && this.state.data.length==0 &&(
                  <div style={{marginTop:50,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <span>Cet organisme n'a pas encore d'actualités.</span>
                  </div>
              )}

              <BlogList
                  context={context}
                  data={this.state.data}
                  nbPages={this.state}
                  page={this.state.page}
                  onPageChange={(page)=>{
                      logger.debug({ page }, "onPageChange")
                      this.getData(page)
                  }}
              />

          </div>
        )
    }
}

/*

*/
